// import React from "react";
// import { BsArrowRight } from "react-icons/bs";
// import { FaWhatsapp } from "react-icons/fa";
// import { TbCurrentLocation } from "react-icons/tb";
// import img2 from "../../../Assets/Images/modernHouse.png";
// import img3 from "../../../Assets/Images/leavingRoom.png";
// import img4 from "../../../Assets/Images/apartment.png";
// import bed from "../../../Assets/Images/hosteBed.png";
// import hostelBed from "../../../Assets/Images/hosteBed.png";
// import hostelBed2 from "../../../Assets/Images/hosteBed2.png";
// import hostelBed3 from "../../../Assets/Images/hosteBed3.png";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// const slides = [
//   {
//     image: hostelBed,
//     mainText: "Premium Hostels and PG Accommodations in Bhubaneswar",
//     subText:
//       "Professionally Managed Living Spaces for Students and  Professionals",
//   },
//   {
//     image: hostelBed2,
//     mainText: "Premium Hostels and PG Accommodations in Bhubaneswar",
//     subText:
//       "Professionally Managed Living Spaces for Students and  Professionals",
//   },
//   {
//     image: hostelBed3,
//     mainText: "Premium Hostels and PG Accommodations in Bhubaneswar",
//     subText:
//       "Professionally Managed Living Spaces for Students and  Professionals",
//   },
// ];

// function Hero() {
//   return (
//     <div className="flex lg:flex-row flex-col gap-8  lg:mt-[107px] md:mt-[73px] mt-[70px] lg:px-16 lg:p-6">
//       <div>
//         <Swiper
//           modules={[Navigation, Pagination, Autoplay]}
//           spaceBetween={30}
//           slidesPerView={1}
//           navigation
//           pagination={{ clickable: true }}
//           autoplay={{ delay: 3000, disableOnInteraction: false }}
//           loop={true}
//         >
//           {slides.map((slide, index) => (
//             <SwiperSlide
//               key={index}
//               className=" w-full grid lg:grid-cols-2 grid-cols-1 gap-4 relative"
//             >
//               <div></div>
//               <div>
//                 <img
//                   src={slide.image}
//                   alt={slide.subText}
//                   className="object-cover w-full   xl:h-96 h-80 rounded-md"
//                 />
//               </div>
//               <div className="hidden lg:flex flex-col absolute ">
//                 <h1
//                   className="xl:text-5xl text-3xl font-semibold text-[#052240]  tracking-wide w-[70%] xl:leading-relaxed mt-1"
//                   style={{ fontFamily: "Anton" }}
//                 >
//                   {slide.mainText}
//                 </h1>
//                 <p className="text-[#494949] italic  text-xl xl:w-[30%] w-[50%] tracking-wide xl:py-5 py-2 xl:leading-[2rem] leading-[2rem]">
//                   {slide.subText}
//                 </p>

//                 {/* Search Bar */}
//                 <div className="flex items-center border rounded-md shadow-sm px-4 py-2 sm:w-[75%] w-full bg-white ">
//                   <input
//                     type="text"
//                     placeholder="Find In and Around...."
//                     className="flex-1 outline-none bg-transparent text-gray-700 placeholder-gray-500"
//                   />
//                   <div className="flex gap-3">
//                     {" "}
//                     <button className="p-2 bg-[#EDF6FF] text-[#235784] rounded-full">
//                       <TbCurrentLocation size={18} />
//                     </button>
//                     <button className="py-2 px-4 bg-[#235784] text-[#ffffff] rounded-md">
//                       <h1 className="text-sm">Search</h1>
//                     </button>
//                   </div>
//                 </div>

//                 {/* Slider Dots */}
//               </div>
//               <div className="lg:hidden flex flex-col gap-2 absolute mt-4  sm:pt-10 pt-5 bottom-0 top-0 bg-black bg-opacity-40  sm:px-20 px-6">
//                 <h1
//                   className="xl:text-5xl sm:text-3xl text-2xl font-medium text-gray-200  text-center tracking-widest px-2 xl:leading-[3.5rem] sm:leading-[2.5rem] leading-[2rem] "
//                   style={{ fontFamily: "Anton" }}
//                 >
//                   {slide.mainText}
//                 </h1>
//                 <p className="text-white text-center italic xl:mt-2 text-md xl:w-[30%] tracking-wide xl:py-5 py-2 xl:leading-[2.5rem] sm:leading-[2rem] leading-[1.7rem] ">
//                   {slide.subText}
//                 </p>

//                 {/* Search Bar */}
//                 <div className="flex items-center border rounded-md shadow-sm sm:px-4 px-2 py-2 sm:w-[80%] w-[100%] bg-white mx-auto ">
//                   <input
//                     type="text"
//                     placeholder="Find In and Around...."
//                     className="flex-1 outline-none bg-transparent text-gray-700 placeholder-gray-500"
//                   />
//                   <div className="flex sm:gap-3">
//                     {" "}
//                     <button className="p-2 bg-[#EDF6FF] text-[#235784] rounded-full sm:flex hidden">
//                       <TbCurrentLocation size={18} />
//                     </button>
//                     <button className="py-2 px-4 bg-[#235784] text-[#ffffff] rounded-md">
//                       <h1 className="text-sm">Search</h1>
//                     </button>
//                   </div>
//                 </div>

//                 {/* Slider Dots */}
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>

//       {/* Right Section */}
//       <div className=" flex flex-col xl:gap-8 gap-10 lg:px-0 sm:px-16 px-6 lg:pb-0 pb-10">
//         {/* Cards */}
//         {[
//           {
//             title: "Modern Student Housing",
//             img: img2,
//           },
//           {
//             title: "Co-Living for Professionals",
//             img: img3,
//           },
//           {
//             title: "Managed Apartments",
//             img: img4,
//           },
//         ].map((item, index) => (
//           <div
//             key={index}
//             className="relative rounded-lg overflow-hidden shadow-md"
//           >
//             <img
//               src={item.img}
//               alt={item.title}
//               className="w-full lg:h-full h-28 object-cover"
//             />
//             <div className="absolute inset-0 flex xl:justify-between items-center xl:items-start p-4 xl:flex-col">
//               <h3 className="text-[#151B56] font-bold text-lg xl:w-[60%] w-full">
//                 {item.title}
//               </h3>
//               <div className="h-6 w-6 bg-white rounded-full flex items-center justify-center">
//                 {" "}
//                 <BsArrowRight className="text-black" />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* WhatsApp Button */}
//       <div className="fixed bottom-6 right-6 bg-green-500 p-3 rounded-full shadow-lg text-white cursor-pointer z-50">
//         <FaWhatsapp size={28} />
//       </div>
//     </div>
//   );
// }

// export default Hero;

// import React from "react";
// import { BsArrowRight } from "react-icons/bs";
// import { FaWhatsapp } from "react-icons/fa";
// import { TbCurrentLocation } from "react-icons/tb";
// import img2 from "../../../Assets/Images/modernHouse.png";
// import img3 from "../../../Assets/Images/leavingRoom.png";
// import img4 from "../../../Assets/Images/apartment.png";
// import bed from "../../../Assets/Images/hosteBed.png";
// import hostelBed from "../../../Assets/Images/hosteBed.png";
// import hostelBed2 from "../../../Assets/Images/hosteBed2.png";
// import hostelBed3 from "../../../Assets/Images/hosteBed3.png";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// const slides = [
//   {
//     image: hostelBed,
//     mainText: "Top Rated PG in Bhubaneswar",
//     subText:
//       "Experience the best of comfort, security, and community at Yostel's top-rated PGs in Bhubaneswar",
//   },
//   {
//     image: hostelBed2,
//     mainText: "We Are Not Just a PG, We Are an Experience",
//     subText:
//       "More than just a place to stay — Yostel offers a vibrant community, personal space, and convenience.",
//   },
//   {
//     image: hostelBed3,
//     mainText: "Premium Hostels and PG Accommodations in Bhubaneswar",
//     subText:
//       "Professionally managed spaces designed for students and professionals who want more than just a room",
//   },
//   {
//     image: hostelBed3,
//     mainText: "Affordable Hostels and PG in Bhubaneswar—No Brokerage Fees",
//     subText:
//       "Enjoy hassle-free living with no hidden fees and affordable, fully furnished rooms.",
//   },
//   {
//     image: hostelBed3,
//     mainText:
//       "Convenient Hostels and PG Near Colleges and Workplaces in Bhubaneswar",
//     subText:
//       "Enjoy hassle-free living with no hidden fees and affordable, fully furnished rooms.",
//   },
// ];

// function Hero() {
//   return (
//     <div className="flex md:flex-row flex-col gap-4 mt-[70px] md:p-6 lg:p-12 lg:pb-4 px-6 mb-4">
//       {/* Left Section - Swiper */}
//       <div className="relative w-full md:w-[65%] md:h-[500px] flex flex-col justify-between">
//         <div className="relative flex-1">
//           <Swiper
//             modules={[Navigation, Pagination, Autoplay]}
//             spaceBetween={50}
//             slidesPerView={1}
//             navigation
//             pagination={{ clickable: true }}
//             autoplay={{ delay: 3000, disableOnInteraction: false }}
//             loop={true}
//             className="h-full"
//           >
//             {slides.map((slide, index) => (
//               <SwiperSlide
//                 key={index}
//                 className="relative w-full h-[450px] md:h-[500px] overflow-hidden rounded-lg"
//               >
//                 {/* Background Image with Overlay */}
//                 <div className="absolute inset-0 z-0">
//                   <img
//                     src={slide.image}
//                     alt={slide.subText}
//                     className="object-cover w-full h-full"
//                   />
//                   <div className="absolute inset-0 bg-black bg-opacity-50"></div>
//                 </div>

//                 {/* Text Content */}
//                 <div className="relative z-10 h-full w-full px-6 lg:px-8 flex items-start justify-start flex-col md:pt-16 pt-8">
//                   <h1 className="text-white xl:text-5xl text-2xl font-bold tracking-wide sm:w-[70%] xl:leading-[3.2rem] leading-[2.5rem] text-center md:text-start">
//                     {slide.mainText}
//                   </h1>
//                   <p className="text-white italic text-md md:text-xl w-full lg:w-[90%] tracking-wide xl:py-5 py-2 xl:leading-[2rem] leading-[2rem] text-center md:text-start">
//                     {slide.subText}
//                   </p>
//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>

//         {/* Search Bar Below Swiper */}
//         {/* <div className="absolute bottom-14 w-full z-20 lg:px-8 px-6">
//           <div className="flex items-center border rounded-md shadow-sm px-4 py-2 w-full bg-white">
//             <input
//               type="text"
//               placeholder="Find In and Around...."
//               className="flex-1 outline-none bg-transparent text-gray-700 placeholder-gray-500"
//             />
//             <div className="flex gap-1">
//               <button className="py-2 px-4 bg-[#235784] text-white rounded-md">
//                 <h1 className="text-sm">Search</h1>
//               </button>
//             </div>
//           </div>
//         </div> */}
//         <div className="absolute bottom-14 w-full z-20 lg:px-8 px-4">
//           <div className="flex flex-row items-center border rounded-md shadow-sm px-4 py-2 w-full bg-white gap-2">
//             <input
//               type="text"
//               placeholder="Find In and Around...."
//               className="flex-1 min-w-[150px] outline-none bg-transparent text-gray-700 placeholder-gray-500 text-sm sm:text-base"
//             />
//             <button className="md:py-2 md:px-4 bg-[#235784] text-white rounded-md text-sm whitespace-nowrap">
//               Search
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Right Section - Cards */}
//       <div className="w-full lg:w-[35%] md:h-[500px] h-full flex flex-col justify-between gap-4">
//         {[
//           {
//             title: "Modern Student Housing",
//             img: img2,
//           },
//           {
//             title: "Co-Living for Professionals",
//             img: img3,
//           },
//           {
//             title: "Managed Apartments",
//             img: img4,
//           },
//         ].map((item, index) => (
//           <div
//             key={index}
//             className="relative rounded-lg overflow-hidden shadow-md flex-1 min-h-[150px]"
//           >
//             <img
//               src={item.img}
//               alt={item.title}
//               className="w-full h-full object-cover"
//             />
//             <div className="absolute inset-0 flex xl:justify-between items-center xl:items-start p-4 xl:flex-col">
//               <h3 className="text-[#151B56] font-bold text-lg xl:w-[60%] w-full">
//                 {item.title}
//               </h3>
//               <div className="h-6 w-6 bg-white rounded-full flex items-center justify-center mt-2 xl:mt-0">
//                 <BsArrowRight className="text-black" />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* WhatsApp Button */}
//       <div className="fixed bottom-6 right-6 bg-green-500 p-3 rounded-full shadow-lg text-white cursor-pointer z-50">
//         <FaWhatsapp size={28} />
//       </div>
//     </div>
//   );
// }

// export default Hero;

import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { FaWhatsapp } from "react-icons/fa";
import { TbCurrentLocation } from "react-icons/tb";
import img2 from "../../../Assets/Images/modernHouse.png";
import img3 from "../../../Assets/Images/leavingRoom.png";
import img4 from "../../../Assets/Images/apartment.png";
import bed from "../../../Assets/Images/hosteBed.png";
import hostelBed from "../../../Assets/Images/hosteBed.png";
import hostelBed2 from "../../../Assets/Images/hosteBed2.png";
import hostelBed3 from "../../../Assets/Images/hosteBed3.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const slides = [
  {
    image: hostelBed,
    mainText: "Top Rated PG in Bhubaneswar",
    subText:
      "Experience the best of comfort, security, and community at Yostel's top-rated PGs in Bhubaneswar",
  },
  {
    image: hostelBed2,
    mainText: "We Are Not Just a PG, We Are an Experience",
    subText:
      "More than just a place to stay — Yostel offers a vibrant community, personal space, and convenience.",
  },
  {
    image: hostelBed3,
    mainText: "Premium Hostels and PG Accommodations in Bhubaneswar",
    subText:
      "Professionally managed spaces designed for students and professionals who want more than just a room",
  },
  {
    image: hostelBed3,
    mainText: "Affordable Hostels and PG in Bhubaneswar—No Brokerage Fees",
    subText:
      "Enjoy hassle-free living with no hidden fees and affordable, fully furnished rooms.",
  },
  {
    image: hostelBed3,
    mainText:
      "Convenient Hostels and PG Near Colleges and Workplaces in Bhubaneswar",
    subText:
      "Enjoy hassle-free living with no hidden fees and affordable, fully furnished rooms.",
  },
];

const Hero = () => {
  const navigate = useNavigate();

  return (
    <div className="flex md:flex-row flex-col gap-6 mt-[70px] md:p-6 lg:p-12 lg:pb-4 px-6 mb-4">
      {/* Left Section - Swiper */}
      <div className="relative w-full md:w-[60%] md:h-[500px] flex flex-col justify-between">
        <div className="relative flex-1">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            className="h-full"
          >
            {slides.map((slide, index) => (
              <SwiperSlide
                key={index}
                className="relative w-full h-[450px] md:h-[500px] overflow-hidden rounded-lg"
              >
                {/* Background Image with Overlay */}
                <div className="absolute inset-0 z-0">
                  <img
                    src={slide.image}
                    alt={slide.subText}
                    className="object-cover w-full h-full"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                </div>

                {/* Text Content */}
                <div className="relative z-10 h-full w-full px-6 lg:px-8 flex items-start justify-start flex-col md:pt-16 pt-8">
                  <h1
                    className="text-white  lg:text-4xl  text-2xl font-bold tracking-wide sm:w-[70%] xl:leading-[3.2rem] leading-[2.5rem] text-center md:text-start"
                    style={{ fontFamily: '"Roboto", sans-serif' }}
                  >
                    {slide.mainText}
                  </h1>
                  <p
                    className="text-white italic text-md md:text-xl w-full lg:w-[90%] tracking-wide xl:py-5 py-2 xl:leading-[2rem] leading-[2rem] text-center md:text-start"
                    style={{ fontFamily: '"Roboto", sans-serif' }}
                  >
                    {slide.subText}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="absolute bottom-8 md:bottom-14 w-full z-20 lg:px-8 px-4">
          <div className="flex flex-row items-center border rounded-md shadow-sm px-4 py-2 w-full bg-white gap-2">
            <input
              type="text"
              placeholder="Find In and Around...."
              className="flex-1 min-w-[150px] outline-none bg-transparent text-gray-700 placeholder-gray-500 text-sm sm:text-base"
            />
            <button className="py-1 px-2 text-xs md:py-2 md:px-4 bg-[#235784] text-white rounded-md md:text-sm whitespace-nowrap">
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Right Section - Cards */}
      <div className="w-full lg:w-[40%] md:h-[500px] h-full flex flex-col justify-between gap-4">
        {[
          {
            title: "Modern Student Housing",
            img: img2,
            onHover: "Comfortable, Secure, Student-Focused Living",
          },
          {
            title: "Co-Living for Professionals",
            img: img3,
            onHover: "Collaborative, Flexible, Inspiring Workspaces",
          },
          {
            title: "Managed Apartments",
            img: img4,
            onHover: "Private, Convenient, Fully Managed Spaces",
          },
        ].map((item, index) => (
          <div
            key={index}
            className="relative rounded-lg overflow-hidden shadow-md flex-1 min-h-[150px] group cursor-pointer"
            onClick={() => navigate("/property-page")}
          >
            <img
              src={item.img}
              alt={item.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />

            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#167F9D] to-[#D0D0D0] opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>

            {/* Title - Hidden on hover */}
            <div className="absolute inset-0 items-center flex xl:justify-between xl:items-start p-4 transition-opacity duration-300 group-hover:opacity-0">
              <h3 className="text-[#151B56] font-bold text-lg">{item.title}</h3>
            </div>

            {/* Hover Text - Shown only on hover */}
            <div className="absolute inset-0 flex opacity-0 group-hover:opacity-100 transition-opacity duration-300 xl:w-[60%] w-full p-4">
              <p className="text-white font-semibold text-lg">{item.onHover}</p>
            </div>

            {/* Icon remains on top */}
            <div className="absolute bottom-4 left-4 h-6 w-6 bg-white rounded-full flex items-center justify-center z-10">
              <BsArrowRight className="text-black" />
            </div>
          </div>
        ))}
      </div>

      {/* WhatsApp Button */}
      <div
        className="fixed bottom-6 right-6 bg-green-500 p-3 rounded-full shadow-lg text-white cursor-pointer z-50"
        onClick={() => window.open(`https://wa.me/8328991641`, "_blank")}
      >
        <FaWhatsapp size={28} />
      </div>
    </div>
  );
};

export default Hero;
